import { Switch, Route, withRouter } from "react-router-dom";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import NotifyContextProvider from "../context/notifyContext";
import NotifyMsg from "../Utills/Notification";

//========================= ADD NEW ROUTE HERE  ===================================
//========================  name of the folder and path of the website "" URL "" ====================================
// To add a new route just put the name of the path or route 
// in path key and also put the name of the folder name that contains page this folder must be
//  nested in container folder with index.js/index.jsx file

const components = [
  { name: "AllOffers", path: "/" },
  { name: "AllOffers", path: "/Home" },
  // { name: "Home", path: "/" },
  // { name: "Home", path: "/Home" },
  { name: "Signup", path: "/signup" },
  { name: "Profile", path: "/profile" },
  { name: "Listing", path: "/listing" },
  { name: "YachtDetail", path: "/yachtDetail/:id" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
  { name: "Blogs", path: "/blogs" },
  { name: "Event", path: "/events" },
  { name: "manageTrips", path: "/manageTrips" },
  { name: "AddBoat", path: "/AddBoat" },
  { name: "Chat", path: "/inbox" },
  { name: "Chat", path: "/inbox/:id" },
  { name: "MyListings", path: "/myListings" },
  // yacht
  { name: "CreateYacht", path: "/createYacht" },
  { name: "TripSummary", path: "/tripSummary" },
  { name: "TripSummary", path: "/tripSummary/:id" },
  // yacht book
  { name: "FinalizeBooking", path: "/finalizeBooking/" },
  { name: "FinalizeBooking", path: "/finalizeBooking/:id" },
  // all offers
  { name: "AllOffersHero", path: "/allOffers" },
  { name: "AllOffersResult", path: "/search/" },
  { name: "AllOffersResult", path: "/search/:locationName" },
  { name: "AllOffersResult", path: "/search/:locationName/:query" },
  { name: "AllOffersResult", path: "/search/:locationName/:query/:time" },
  { name: "AllOffersDetail", path: "/OfferDetails" },
  { name: "AllOffersDetail", path: "/OfferDetails/:id" },
  { name: "ConfirmBooking", path: "/confirmBooking/:id" },
  { name: "BookingConfirmed", path: "/bookingCompleted/:id" },
  // 
  { name: "Favorites", path: "/favorites" },
  { name: "PostReview", path: "/postReview" },
  { name: "Experiences", path: "/experience" },
  // Admin
  { name: "Admin", path: "/dashboard" },
  { name: "Admin", path: "/dashboard/:tabName" },
  { name: "Admin", path: "/dashboard/:tabName/:subTabName" },
  // 404
  { name: "404", path: "" },
];

// ===============
const AppRoute = () => {
  return (
    <>
      {/* Routes */}
      <Route
        render={({ location }) => {
          // Scroll top when page change
          window.scrollTo({ top: 0, behavior: "smooth" })
          return (
            <div style={{ position: "relative" }}>
              <NotifyContextProvider>
                {/* Header */}
                {!location.pathname?.includes('OfferDetails') && !location.pathname?.includes('dashboard') &&
                  <Header />
                }
                {/*  */}
                <Switch
                  location={location}
                  key={location.pathname}>
                  {components.map((el, i) => {
                    const Component = require(`../container/${el.name}`)[
                      el.nested || "default"
                    ];
                    return (
                      <Route key={i} path={el.path} component={Component} exact />
                    );
                  })};
                  {/*  */}
                </Switch>
                {/* Alert Message */}
                <NotifyMsg />
                {/* <Loader type="webLoader" /> */}
                {/* ====== Footer ========= */}
                {!location.pathname?.includes('dashboard') &&
                  <Footer />
                }
              </NotifyContextProvider>
            </div>
          );
        }}
      />

    </>
  );
};

export default withRouter(AppRoute);
